var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
import { TooltipApi } from "sb-resp-ui";
var ToggleOddsBtn = /** @class */ (function (_super) {
    __extends(ToggleOddsBtn, _super);
    function ToggleOddsBtn(props) {
        var _this = _super.call(this, props) || this;
        _this.onClickHandler = function (e) {
            e.stopPropagation();
            _this.props.onClick();
        };
        _this.setTooltipMsg = TooltipApi.getInstance().setMessage.bind(_this);
        _this.btnRef = React.createRef();
        return _this;
    }
    ToggleOddsBtn.prototype.componentDidUpdate = function () {
        if (this.btnRef.current) {
            TooltipApi.getInstance().refresh(this.btnRef.current);
        }
    };
    ToggleOddsBtn.prototype.render = function () {
        var tooltip = this.setTooltipMsg(this.props.tooltipMessage);
        return (React.createElement("div", __assign({ ref: this.btnRef, className: "rj-ev-list__toggle-odds-btn rj-ev-list__toggle-odds-btn--" + this.props.toggled, onClick: this.onClickHandler }, tooltip, { "data-uat": "div-ev-list-toggle-odds-btn" }),
            React.createElement("span", { className: "icon i-14 i-o-ev-up-down" })));
    };
    return ToggleOddsBtn;
}(React.PureComponent));
export { ToggleOddsBtn };
//# sourceMappingURL=ToggleOddsBtn.js.map